import { jsx as m } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { css as i, cx as l } from "@/styled-system/css";
import { paragraphRecipe as f } from "./paragraph.styles.js";
const d = n(
  (a, r) => {
    const { className: t, css: o, color: s = "text.neutral", textStyle: e = "body", ...c } = a, p = i(f.raw({ color: s, textStyle: e }), o);
    return /* @__PURE__ */ m(
      "p",
      {
        ref: r,
        "data-c11n-component": "Paragraph",
        "data-c11n-version": "10.0.0-alpha.19",
        className: l("c11n", "c11n-semantic", p, t),
        ...c
      }
    );
  }
);
d.displayName = "Paragraph";
export {
  d as Paragraph
};
//# sourceMappingURL=paragraph.js.map
